import type { Task } from "@dune/types";
import { formatSimpleDate } from "@dune/utils";
import type { ColumnDef } from "@tanstack/react-table";

import {
	TaskDueDate,
	TaskStatusBadge,
	TaskStatusIcon,
} from "../../../../component/tasks";

export const propositionTasksColumns: ColumnDef<Task>[] = [
	{
		id: "statusIcon",
		header: "",
		cell: ({ row }) => (
			<div className="flex items-center justify-center">
				<TaskStatusIcon task={row.original} />
			</div>
		),
		size: 50,
		enableSorting: false,
	},
	{
		accessorKey: "title",
		header: "Titre",
		cell: ({ row }) => (
			<div className="font-medium truncate">{row.original.title}</div>
		),
		size: 300,
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => <TaskStatusBadge status={row.original.status} />,
		size: 200,
	},
	{
		accessorKey: "assignee",
		header: "Assigné à",
		cell: ({ row }) => {
			const assignee = row.original.assignee;
			return assignee ? `${assignee.firstname} ${assignee.lastname}` : "-";
		},
		size: 200,
	},
	{
		accessorKey: "dueDate",
		header: "Date d'échéance",
		cell: ({ row }) => (
			<TaskDueDate task={row.original} showIcon={false} variant="full" />
		),
		size: 200,
	},
	{
		accessorKey: "createdAt",
		header: "Créé le",
		cell: ({ row }) => formatSimpleDate(row.original.createdAt),
		size: 150,
	},
];
